var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [(_vm.company.email) ? _c('a', {
    staticClass: "contact details__button cm-button",
    attrs: {
      "href": 'mailto:' + _vm.company.email
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("contact")))]) : _vm._e(), _vm._v(" "), (_vm.company.locations && !_vm.company.remote) ? _vm._m(0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-list sidebar-box"
  }, [(_vm.editable) ? _c('a', {
    staticClass: "edit-link ss-icon",
    attrs: {
      "href": _vm.editCompanyPath,
      "title": "Edit company"
    }
  }, [_vm._v("compose")]) : _vm._e(), _vm._v(" "), _c('dl', [(_vm.isOnTheWeb) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.I18n.t("on_the_web")))]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [(_vm.company.website) ? _c('a', {
    attrs: {
      "href": _vm.company.website
    }
  }, [_vm._v(_vm._s(_vm.websiteHostname))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "social-links"
  }, _vm._l((_vm.socialNetworks), function(socialNetwork) {
    return _c('li', {
      key: socialNetwork.service,
      staticClass: "social-link"
    }, [_c('a', {
      attrs: {
        "href": socialNetwork.url
      }
    }, [_c('i', {
      staticClass: "ss-icon ss-social-regular"
    }, [_vm._v(_vm._s(socialNetwork.service))]), _vm._v(" "), _c('span', {
      staticClass: "social-link__username"
    }, [_vm._v(_vm._s(socialNetwork.username))])])])
  }))])])] : _vm._e(), _vm._v(" "), (!_vm.company.remote) ? [(_vm.company.locations.length > 1 || _vm.company.remote_employees) ? _c('div', [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v("Locations")]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', {
    staticClass: "location-list"
  }, [_vm._l((_vm.company.locations), function(location, i) {
    return _c('li', [(i == 0 && _vm.company.locations.length > 1) ? _c('div', {
      staticClass: "hq-tag"
    }, [_vm._v("\n                  HQ\n                ")]) : _vm._e(), _vm._v("\n                " + _vm._s(location.address) + "\n              ")])
  }), _vm._v(" "), (_vm.company.remote_employees) ? _c('li', {
    staticClass: "remote-friendly-tag"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("wifi")]), _vm._v("\n                We're remote friendly!\n              ")]) : _vm._e()], 2)])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.company.industries.length > 0) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v(_vm._s(_vm.I18n.t("industries")))]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', _vm._l((_vm.company.industries), function(industry, n) {
    return (n < 3 || _vm.industriesExpanded) ? _c('li', {
      key: industry[0],
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.getDirectoryPath('industry_id', industry[0])
      }
    }, [_vm._v(_vm._s(industry[1]))])]) : _vm._e()
  })), _vm._v(" "), (_vm.company.industries.length > 3) ? _c('a', {
    staticClass: "expand",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleIndustries($event)
      }
    }
  }, [(!_vm.industriesExpanded) ? [_vm._v("\n                See all " + _vm._s(_vm.company.industries.length) + "\n              ")] : [_vm._v(" See less ")]], 2) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.company.expertise.length > 0) ? [_c('div', {
    staticClass: "detail-group"
  }, [_c('dt', {
    staticClass: "detail-label"
  }, [_vm._v("\n            " + _vm._s(_vm.I18n.t("activerecord.attributes.company.skill_tag_ids")) + "\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "detail-value"
  }, [_c('ul', _vm._l((_vm.company.expertise), function(expertise, n) {
    return (n < 3 || _vm.expertiseExpanded) ? _c('li', {
      key: expertise[0],
      staticClass: "tag"
    }, [_c('a', {
      attrs: {
        "href": _vm.getDirectoryPath('skill_tag_id', expertise[0])
      }
    }, [_vm._v(_vm._s(expertise[1]))])]) : _vm._e()
  })), _vm._v(" "), (_vm.company.expertise.length > 3) ? _c('a', {
    staticClass: "expand",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleExpertise($event)
      }
    }
  }, [(!_vm.expertiseExpanded) ? [_vm._v("\n                See all " + _vm._s(_vm.company.expertise.length) + "\n              ")] : [_vm._v(" See less ")]], 2) : _vm._e()])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.labels), function(label, key) {
    return (_vm.company[key]) ? [_c('div', {
      staticClass: "detail-group"
    }, [_c('dt', {
      staticClass: "detail-label"
    }, [_vm._v(_vm._s(label))]), _vm._v(" "), _c('dd', {
      staticClass: "detail-value"
    }, [_vm._v(_vm._s(_vm._self[key] || _vm.company[key]))])])] : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.company.global) ? _c('div', {
    staticClass: "sponsor"
  }, [_c('div', {
    staticClass: "global-partner"
  }, [_vm._v("\n      " + _vm._s(_vm.I18n.t("global_partner")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "global-partner-link"
  }, [_c('a', {
    attrs: {
      "href": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("what_is_this_question")))])])]) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.isForm) ? _c('a', {
    staticClass: "cm-button details__button view-company",
    attrs: {
      "href": _vm.viewCompanyPath
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("view_company")))]) : (_vm.editable) ? _c('a', {
    staticClass: "cm-button details__button edit-company",
    attrs: {
      "href": _vm.editCompanyPath
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("edit_company")))]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('static-map', {
    attrs: {
      "src": _vm.company.google_maps_src
    }
  })
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d676522","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/details.vue
// module id = null
// module chunks = 